import client from './client';

export const productsApi = {
  getAll: (params) => client.get('/products', { params }),
  getById: (id) => client.get(`/products/${id}`),
  getByCode: (code) => client.get(`/products/code/${code}`),
  create: (data) => client.post('/products', data),
  update: (id, data) => client.put(`/products/${id}`, data),
  updateByCode: (code, data) => client.put(`/products/code/${code}`, data),
  delete: (id) => client.delete(`/products/${id}`),
  deleteByCode: (code) => client.delete(`/products/code/${code}`)
};
